import { useEffect } from "react";
import { SCOPE_OPTIONS } from "@/Enums/scopes";

export function useTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | Emma by Gidås` : "Emma by Gidås";
  }, [title]);
}

/**
 * useKeyPress
 * @param {string} key - the name of the key to respond to, compared against event.key
 * @param {function} action - the action to perform on key press
 * @param {array}deps - the dependencies to watch for changes
 */
export function useKeypress(key, action, deps = []) {
  useEffect(() => {
    function onKeyup(e) {
      if (e.key === key) action();
    }
    window.addEventListener("keyup", onKeyup);
    return () => window.removeEventListener("keyup", onKeyup);
  }, deps);
}

export function useCalculateEmissionValues(values, format = "default") {
  const totalEmissions = {
    total: 0,
    scopes: {},
  };

  SCOPE_OPTIONS.forEach((scope) => {
    totalEmissions.scopes[scope.value] = values.reduce((acc_value, value) => {
      return (
        acc_value +
        (value.emissions?.[format]?.scopes?.[scope.value]?.value || 0)
      );
    }, 0);
  });

  totalEmissions.total = values.reduce((acc_value, value) => {
    return acc_value + (value.emissions?.[format]?.total || 0);
  }, 0);

  return totalEmissions;
}
